module.exports = __webpack_public_path__ + "img/slightly-frowning-face.944a6d9b.png";